import { Link, useParams } from 'react-router-dom';

import { Alert } from '../../../../components/Alert';
import { PageSpinner } from '../../../../components/PageSpinner';
import { billingApi } from '../../../../features/billing/billing.api';
import { PaymentReceiptDisplay } from '../../../../features/billing/PaymentReceiptDisplay';
import { useSessionQuery as useQuery } from '../../../../hooks/useSessionQuery';
import { toDisplayMessage } from '../../../../lib/error-message';
import { paths } from '../../../../routes/paths';
import styles from '../../AppPages.module.css';

export function PaymentReceiptPage(): React.JSX.Element {
  const { id = '' } = useParams<{ id: string }>();

  const receipt = useQuery({
    queryKey: ['customer', 'payments', id, 'receipt'],
    queryFn: () => billingApi.getPaymentReceipt(id),
    enabled: id !== '',
  });

  if (receipt.isPending) {
    return <PageSpinner label="Loading receipt" />;
  }

  if (receipt.isError) {
    return <Alert tone="error">{toDisplayMessage(receipt.error)}</Alert>;
  }

  return (
    <div className={styles.page}>
      <p>
        <Link to={paths.customerPayments}>Back to payment history</Link>
      </p>

      <PaymentReceiptDisplay data={receipt.data} />
    </div>
  );
}
